import React, { useEffect } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

import Grid from '@mui/material/Grid';
import {rater_layer_list, mapStyleLlist} from './Const'
import { useSelector, useDispatch } from 'react-redux';
import { setMapStyle } from '../../../redux/actions/mapaction';
import Typography  from '@mui/material/Typography';
import Divider  from '@mui/material/Divider';
import { bgColors } from '../../utils/bgColor';
export default function RasterlayerRadiobutton(){
  const mapstyle = useSelector(state => 
    state.mapreducer.mapstyle)
  // console.log(activeGlobalRaster)
  const dispatch = useDispatch()
  const [value, setValue] = React.useState(mapstyle);
  useEffect(()=> {
    dispatch(setMapStyle(value))
  },[value])
  const handleChange = (event) => {
    setValue(event.target.value);
    // dispatch(setMapStyle(event.target.value))
  };
  const mapstyleslabel = Object.keys(mapStyleLlist)

return (
    <FormControl >
    <RadioGroup
        aria-labelledby="Raster-group-label"
        name="Raster-group"
        value={value}
        onChange={handleChange}
    > 
      <Grid container spacing={1} display='flex' padding={5} direction={"column"}>
        {mapstyleslabel.map((item,index)=> 
            <FormControlLabel value={item} control={<Radio />} label={
              <Typography 
              sx ={{
                  fontSize: 16, 
                  //  fontWeight:'bold',
                   fontFamily:'serif',
                   padding:'0.5rem',
                   color:bgColors.grey_800
                   }}
                >{item}
              </Typography> 
            }
            key = {`${item}_${index}_radio`}
            />
            )
        }
        </Grid>
    </RadioGroup>
    </FormControl>
);
}
